import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import history from './history';
import registry from './registry';
import './middleware/ui/ducks/reducers';

// sample reducer
// const initialState = {
//   main: {
//     show: false
//   }
// };

// function reducer(state = initialState.main, action) {
//   const { type, payload } = action;

//   switch (type) {
//     case 'show_hide_child':
//       return {
//         ...state,
//         show: payload
//       };

//     default:
//       return state;
//   }
// }

registry.register('router', connectRouter(history));

export const combine = reducers => {
  const reducerNames = Object.keys(reducers);
  Object.keys(registry.getDefaultStates()).forEach(item => {
    if (reducerNames.indexOf(item) === -1) {
      // eslint-disable-next-line no-param-reassign
      reducers[item] = (state = {}) => state;
    }
  });

  return combineReducers(reducers);
};

const appReducer = reducers => combine({ ...reducers });
const rootReducer = (reducers = registry.getReducers()) => (state, action) => {
  let newState = { ...state };
  if (action.type === '@@RESET_APP') {
    newState = {
      ...registry.getDefaultStates(),
      router: state.router,
      ui: state.ui
    };
  }

  return appReducer(reducers)(newState, action);
};

export default rootReducer;
